module.exports = __webpack_public_path__ + "img/eur.ee06e13e.svg";